<div class="modal-overlay"
     [class.open]="isOpen()">
  <dialog class="modal-content"
       [class.expanded]="isExpanded()"
       [style.width]="currentWidth()"
       [style.max-width]="currentMaxWidth()"
       [style.height]="currentHeight()"
       [style.max-height]="currentMaxHeight()"
       aria-modal="true">

    <!-- Modal Header -->
    <div class="modal-header">
      <h2>{{ config().title }}</h2>
      <div class="header-buttons">
        @if(config().showExpandButton) {
          <button class="expand-btn" (click)="toggleModalSize()" [title]="isExpanded() ? 'Collapse' : 'Expand'" [attr.aria-label]="isExpanded() ? 'Collapse modal' : 'Expand modal'">
            <span aria-hidden="true">{{ isExpanded() ? '⤢' : '⤡' }}</span>
          </button>
        }
        @if(config().showCloseButton !== false) {
          <button class="close-btn" (click)="close()" aria-label="Close modal">
            <span aria-hidden="true">×</span>
          </button>
        }
      </div>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      @if(contentTemplate()) {
        <ng-container *ngTemplateOutlet="contentTemplate(); context: { $implicit: data(), modal: this }"></ng-container>
      } @else {
        <ng-content></ng-content>
      }
    </div>
  </dialog>
</div>
